import { createContext } from "react";

interface CustomProps {
  formFields: any;
  setFormFields: Function;
  parsingCsvData: any;
  setParsingCsvData: Function;
  columnMapperJson: any;
  setColumnMapperJson: Function;
  isColumnMatch: boolean;
  setColumnMatch: Function;
  csvColumn: any;
  setCsvColumn: Function;
  managingStep: string[];
  setManagingStep: Function;
}

export const ContactContext = createContext({} as CustomProps);
